import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { ColorClassSuffix } from "features/shared/enums/colorClassSuffix";
import { Commodity } from "features/shared/enums/commodity";

export const getCommodityColorSuffix = (commodity: Commodity): ColorClassSuffix => {
  switch (commodity) {
    case "Electricity":
      return ColorClassSuffix.Electricity;
    case "Gas":
      return ColorClassSuffix.Gas;
    case "Heat":
      return ColorClassSuffix.Heat
    default:
      return ColorClassSuffix.Default;
  }
}

export const getCommodityIcon = (commodity: Commodity): IconProp => {
  switch (commodity) {
    case "Electricity":
      return "bolt";
    case "Gas":
      return "fire";
    case "Heat":
      return "thermometer-three-quarters";
    default:
      return "file-alt";
  }
}